import { render, staticRenderFns } from "./ResultsModal.vue?vue&type=template&id=082b6c13&scoped=true&"
import script from "./ResultsModal.vue?vue&type=script&lang=js&"
export * from "./ResultsModal.vue?vue&type=script&lang=js&"
import style0 from "./ResultsModal.vue?vue&type=style&index=0&id=082b6c13&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082b6c13",
  null
  
)

export default component.exports